import React, { useEffect, useState } from "react";
import { db } from "../../firebase";
import {
  collection,
  getDocs,
  addDoc,
  updateDoc,
  deleteDoc,
  doc,
} from "firebase/firestore";
import Swal from "sweetalert2";
import axios from "axios";

export default function ManageFasilitas() {
  const [list, setList] = useState([]);
  const ref = collection(db, "fasilitas");

  const fetchData = async () => {
    const snap = await getDocs(ref);
    const data = snap.docs.map((d) => ({ id: d.id, ...d.data() }));
    setList(data);
  };

  useEffect(() => {
    fetchData();
  }, []);

  // ================= CLOUDINARY =================
  const uploadToCloudinary = async (file) => {
    const data = new FormData();
    data.append("file", file);
    data.append(
      "upload_preset",
      process.env.REACT_APP_CLOUDINARY_UPLOAD_PRESET
    );

    const res = await axios.post(
      `https://api.cloudinary.com/v1_1/${process.env.REACT_APP_CLOUDINARY_CLOUD_NAME}/image/upload`,
      data
    );
    return res.data.secure_url;
  };

  // ================= ADD / EDIT MODAL =================
  const openFormModal = async (item = null) => {
    const isEdit = !!item;

    const { value: form } = await Swal.fire({
      title: isEdit ? "Edit Fasilitas" : "Tambah Fasilitas",
      width: "700px",
      html: `
        <div style="max-height:65vh; overflow-y:auto; text-align:left; padding-right:8px;">
          <style>
            label { font-weight:600; margin-top:10px; display:block; }
            .swal2-input, .swal2-textarea, .swal2-file {
              width:100% !important;
              margin:6px 0 12px 0;
            }
          </style>

          <label>Nama Fasilitas</label>
          <input id="nama" class="swal2-input" value="${item?.nama || ""}">

          <label>Deskripsi</label>
          <textarea id="deskripsi" class="swal2-textarea">${
            item?.deskripsi || ""
          }</textarea>

          <label>Upload Gambar (Opsional)</label>
          <input id="gambarFile" type="file" class="swal2-file">

          <label>Atau URL Gambar</label>
          <input id="gambarUrl" class="swal2-input" value="${
            item?.gambar || ""
          }">
        </div>
      `,
      showCancelButton: true,
      confirmButtonText: isEdit ? "Update" : "Simpan",
      cancelButtonText: "Batal",
      preConfirm: () => {
        const nama = document.getElementById("nama").value;
        if (!nama) {
          Swal.showValidationMessage("Nama fasilitas wajib diisi");
          return false;
        }

        return {
          nama,
          deskripsi: document.getElementById("deskripsi").value,
          gambarFile: document.getElementById("gambarFile").files[0],
          gambarUrl: document.getElementById("gambarUrl").value,
        };
      },
    });

    if (!form) return;

    try {
      Swal.fire({
        title: "Menyimpan...",
        allowOutsideClick: false,
        didOpen: () => Swal.showLoading(),
      });

      let gambarFinal = form.gambarUrl || "";
      if (form.gambarFile) {
        gambarFinal = await uploadToCloudinary(form.gambarFile);
      }

      const payload = {
        nama: form.nama,
        deskripsi: form.deskripsi,
        gambar: gambarFinal,
      };

      if (isEdit) {
        await updateDoc(doc(db, "fasilitas", item.id), payload);
        Swal.fire("Berhasil!", "Fasilitas diperbarui", "success");
      } else {
        await addDoc(ref, payload);
        Swal.fire("Berhasil!", "Fasilitas ditambahkan", "success");
      }

      fetchData();
    } catch (err) {
      console.error(err);
      Swal.fire("Error!", "Gagal menyimpan fasilitas", "error");
    }
  };

  // ================= DELETE =================
  const handleDelete = async (id) => {
    const confirm = await Swal.fire({
      title: "Hapus fasilitas ini?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Ya, hapus",
    });
    if (!confirm.isConfirmed) return;

    await deleteDoc(doc(db, "fasilitas", id));
    Swal.fire("Terhapus!", "Fasilitas berhasil dihapus", "success");
    fetchData();
  };

  // ================= RENDER =================
  return (
    <div className="container mt-4">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h3>Kelola Fasilitas Sekolah</h3>
        <button
          className="btn btn-primary"
          onClick={() => openFormModal()}
        >
          + Tambah Fasilitas
        </button>
      </div>

      <div className="row">
        {list.length === 0 ? (
          <p>Belum ada fasilitas</p>
        ) : (
          list.map((f) => (
            <div key={f.id} className="col-md-4 mb-3">
              <div className="card shadow-sm h-100">
                {f.gambar && (
                  <img
                    src={f.gambar}
                    className="card-img-top"
                    style={{ height: "180px", objectFit: "cover" }}
                    alt={f.nama}
                  />
                )}
                <div className="card-body">
                  <h5>{f.nama}</h5>
                  <p className="text-muted small">{f.deskripsi}</p>
                  <div className="d-flex justify-content-end">
                    <button
                      className="btn btn-secondary btn-sm me-1"
                      onClick={() => openFormModal(f)}
                    >
                      Edit
                    </button>
                    <button
                      className="btn btn-danger btn-sm"
                      onClick={() => handleDelete(f.id)}
                    >
                      Hapus
                    </button>
                  </div>
                </div>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
}
